var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgClinicManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1229_59063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 16.6667V11.6667H13.3334V16.6667H15.8334V3.33341H4.16671V16.6667H6.66671ZM8.33337 16.6667H11.6667V13.3334H8.33337V16.6667ZM17.5 16.6667H19.1667V18.3334H0.833374V16.6667H2.50004V2.50008C2.50004 2.27907 2.58784 2.06711 2.74412 1.91083C2.9004 1.75455 3.11236 1.66675 3.33337 1.66675H16.6667C16.8877 1.66675 17.0997 1.75455 17.256 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V16.6667ZM9.16671 6.66675V5.00008H10.8334V6.66675H12.5V8.33342H10.8334V10.0001H9.16671V8.33342H7.50004V6.66675H9.16671Z",
    fill: "#002244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_59063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgClinicManagement);
export default __webpack_public_path__ + "static/media/svg_clinic_management.e06c3b1a293150f1fa2458073d5d1b8f.svg";
export { ForwardRef as ReactComponent };